import { jobTalentInfoService } from "services/matchingDetails/jobTalentInfo";
import { getAuthorization, getStore } from "./controller";
import { aiInsightsService } from "services/matchingDetails/aiInsights";
import { getChatScriptService } from "services/matchingDetails/getChatScript";
import { updateOverallGradeService } from "services/matchingDetails/updateOverallGrade";
import { sendChatInviteLinkService } from "services/matchingDetails/sendChatInviteLink";

export const getJobTalentInfo = async (id) => {
  const authorization = getAuthorization();

  const { status, data } = await jobTalentInfoService(authorization, id);

  if (status !== 200) {
    console.error("Error", status);
    return false;
  }

  return data;
};

export const aiInsights = async (id, param) => {
  const authorization = getAuthorization();

  const { status, data } = await aiInsightsService(authorization, {
    insight_level: "high",
    job_talent_id: id,
    parameter: param,
  });

  if (status !== 200) {
    console.error("Error", status);
    return false;
  }

  return data;
};

export const getChatScript = async (application_id = "") => {
  const authorization = getAuthorization();
  const { status, data } = await getChatScriptService(authorization, {
    application_id,
  });

  if (status !== 200) {
    console.error("Error", status);
    return false;
  }

  return data;
};

export const getUserPermission = () => {
  const subscribedProduct = getStore().user?.details?.subscribedProduct;

  return subscribedProduct?.find((product) => product === "admin")
    ? true
    : false;
};

export const updateOverallGrade = async (jobId, grade) => {
  const authorization = getAuthorization();
  await updateOverallGradeService(authorization, {
    job_talent_info_id: jobId,
    updated_overallscore_grade: grade,
  });

  return true;
};

export const sendChatInviteLink = async ({ job_talent_infoid }) => {
  const authorization = getAuthorization();
  const { status, data } = await sendChatInviteLinkService(authorization, {
    job_talent_infoid,
  });

  if (status !== 200) {
    console.error("Error", status);
    return false;
  }

  return data;
};
